<main class="fadeIn">
    <div class="container-fluid" #focusedElement>
        <div class="row">
            <div class="col-12">
                <div class="header d-flex justify-content-between">
                    <h1>{{userType}} Listing</h1>
                </div>
            </div>
            <div class="col-12">
                <div class="tab-section">
                    <ul class="nav nav-tabs" role="tablist" id="moving-tabs">
                        <li class="nav-item" role="presentation"
                            *ngIf="checkPermission('getProvider') && (subTypeEvm == subTypes.provider || subTypeEvm == subTypes.both)">
                            <a class="nav-link" [ngClass]="{'active': activeTab === 1}" (click)="switchTab(1)"
                                id="provider-tab" data-bs-toggle="tab" data-bs-target="#provider" role="tab"
                                aria-controls="home" aria-selected="true">Provider</a>
                            <div class="slider" *ngIf="activeTab === 1"></div>
                        </li>
                        <li class="nav-item" role="presentation"
                            *ngIf="checkPermission('getPayer') && (subTypeEvm == subTypes.payer || subTypeEvm == subTypes.both)">
                            <a class="nav-link" [ngClass]="{'active': activeTab === 2}" (click)="switchTab(2)"
                                id="insurance-tab" data-bs-toggle="tab" data-bs-target="#insurance" role="tab"
                                aria-controls="profile" aria-selected="false">Payer</a>
                            <div class="slider" *ngIf="activeTab === 2"></div>
                        </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                        <app-provider-listing
                            *ngIf="activeTab === 1 && checkPermission('getProvider') && ( subTypeEvm == subTypes.provider || subTypeEvm == subTypes.both)"
                            (focus)="focusFn()"></app-provider-listing>
                        <app-insurance-listing
                            *ngIf="activeTab === 2 && checkPermission('getPayer') && ( subTypeEvm == subTypes.payer|| subTypeEvm == subTypes.both)"
                            (focus)="focusFn()"></app-insurance-listing>
                    </div>
                </div>

            </div>
        </div>
    </div>
</main>